// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"359":"775d07e3","651":"7a7677d0","841":"af2978bd","924":"b453a6e9","979":"998748ce"}[chunkId] + ".chunk.css";
};